export default __webpack_public_path__ + "static/media/kistaschoolfirst.b5b86f20.jpg";